import { render, staticRenderFns } from "./CreateOfferButton.vue?vue&type=template&id=52c4023c&scoped=true"
import script from "./CreateOfferButton.vue?vue&type=script&lang=ts"
export * from "./CreateOfferButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c4023c",
  null
  
)

export default component.exports